var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSuccessGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_13855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 84C49.2539 84.0068 54.4573 82.9752 59.3112 80.9646C64.1652 78.954 68.5739 76.0039 72.284 72.284C76.004 68.5738 78.954 64.1651 80.9647 59.3112C82.9753 54.4573 84.0068 49.2539 84 44C84.0067 38.7462 82.9751 33.5428 80.9645 28.6889C78.9539 23.835 76.0039 19.4262 72.284 15.716C68.5739 11.9961 64.1652 9.04603 59.3112 7.0354C54.4573 5.02478 49.2539 3.99323 44 4.00003C38.7462 3.99334 33.5428 5.02494 28.6889 7.03556C23.835 9.04617 19.4262 11.9962 15.716 15.716C11.9962 19.4262 9.04618 23.835 7.03556 28.6889C5.02494 33.5428 3.99334 38.7462 4.00003 44C3.99323 49.2539 5.02478 54.4573 7.0354 59.3112C9.04603 64.1651 11.9961 68.5738 15.716 72.284C19.4262 76.0038 23.835 78.9538 28.6889 80.9644C33.5428 82.9751 38.7462 84.0067 44 84Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28 44L40 56L64 32",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_13855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M-4 -4H92V91.9999H-4V-4Z",
    fill: "#10AD6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccessGreen);
export default __webpack_public_path__ + "static/media/check-success-green.056cd93ff8a54132e581ac9fe8989be8.svg";
export { ForwardRef as ReactComponent };